import propTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import { BtnFavorite } from '../../../../common/BtnFavorite/BtnFavorite.jsx';

const _AddToFavBlock = ({ substStore, labelsStore, isGroup }) => {
  const addLabel = isGroup ? labelsStore.addGroupLabel : labelsStore.addToProducts;
  const removeLabel = isGroup ? labelsStore.removeGroupLabel : labelsStore.removeFromProducts;
  const labelTxt = substStore.isFavorite ? removeLabel : addLabel;

  return (
    <div className="my-cart__btn-fav-shell">
      <BtnFavorite handleClick={() => substStore.toggleFavorite()} store={substStore} />
      <span className="btn-label" onClick={() => substStore.toggleFavorite()}>{labelTxt}</span>
    </div>
  );
};

_AddToFavBlock.propTypes = {
  substStore: propTypes.shape({
    toggleFavorite: propTypes.func.isRequired,
    isFavorite: propTypes.bool.isRequired
  }).isRequired,

  labelsStore: propTypes.shape({
    addToProducts: propTypes.string.isRequired,
    removeFromProducts: propTypes.string.isRequired,
    addGroupLabel: propTypes.string.isRequired,
    removeGroupLabel: propTypes.string.isRequired
  }).isRequired,
  isGroup: propTypes.bool
};

_AddToFavBlock.defaultProps = {
  isGroup: false
};

export const AddToFavBlock = inject('labelsStore')(observer(_AddToFavBlock));
